export default (theme) => ({
  fullScreenIcon: {
    fill: theme.palette.background.white,
  },
});
